export default __webpack_public_path__ + "static/media/time-based-loitering-info.5a69df61.png";